module.exports = __webpack_public_path__ + "img/ppp.7e7426c7.svg";